import * as React from "react";

import MetadataStatus from "./utils/enums/MetadataStatus";
import AudioStatus from "./utils/enums/AudioStatus";

const common = {
  serverError: (
    <>
      Oops, we couldn't connect to the server.
      <br />
      Please try again.
    </>
  ),
};

const resetPassword = {
  passwordPlaceHolder: "Enter a new password",
  confirmPasswordPlaceHolder: "Enter a new password again",
  passwordLabel: "password",
  passwordConfirmLabel: "password confirm",
  errors: {
    strongPassword:
      "A strong password is 8 characters long, and contains at least one number, one uppercase character and one special character",
    multipleErrors:
      "Please enter a password that is a minimum of 8 characters, one uppercase character, and one special character.",
    specialCharacter:
      "Please include a special character to strengthen your new password. Here are some suggestions: ! # & * , ; [ ] + =",
    minimumCharacters:
      "Please enter a password that is a minimum of 8 characters",
    containsNumber: "Please include at least one number",
    containsUpper: "Please include at least one upper case letter",
    troubleSaving:
      "Oops, we had trouble trying to save your new password. Please try again.",
    dontMatch: "Oops, the passwords do not match",
    emailError: "Please enter a valid email address",
  },
};

const login = {
  alerts: {
    multiClientError:
      "This user has been assigned to too many client accounts." +
      " Please contact your admin to update your access to only" +
      " one client account.",
    signedOut: "You have successfully signed out.",
    wrongPassword: (
      <>
        Your email and/or password was incorrect.
        <br />
        Please try again.
      </>
    ),
    sessionExpired: (
      <>
        Your session has expired due to inactivity.
        <br />
        Please sign in again.
      </>
    ),
  },
  errors: {
    emailErrorText: "Please enter a valid email address",
    passwordErrorText:
      "Please enter a password that is a minimum of 8 characters",
  },
  form: {
    email: {
      label: "EMAIL",
      placeholder: "name@mycompany.com",
    },
    password: {
      label: "PASSWORD",
      placeholder: "Enter your password",
    },
    capslockTooltip: "Caps lock is on",
  },
  title: {
    sessionExpired: "Session expired",
    signIn: "Sign In",
    signOut: "Signed Out",
  },
};

const metadata = {
  statuses: {
    [MetadataStatus.DRAFT]: "Draft",
    [MetadataStatus.PENDING_VOICE_TALENT]: "Pending Voice Talent",
    [MetadataStatus.READY_FOR_REVIEW]: "Ready For Review",
    [MetadataStatus.IN_PUBLISH_QUEUE]: "In Publish Queue",
    [MetadataStatus.PUBLISHED]: "Published",
    [MetadataStatus.ARCHIVED]: "Archived",
  },
  errors: {
    publishDateError: "Please select today's date or a future date",
  },
};

const audio = {
  statuses: {
    [AudioStatus.READY_FOR_RECORDING]: "Ready For Recording",
    [AudioStatus.READY_FOR_REVIEW]: "Ready For Review",
    [AudioStatus.APPROVED]: "Approved",
    [AudioStatus.REJECTED]: "Rejected",
  },
};

const constants = {
  common,
  login,
  metadata,
  audio,
  resetPassword,
};

export default constants;
